/**
 * The Maps loader's options, declared once.
 *
 * Four surfaces call `useLoadScript` now — the result page, the console, the
 * map container and the address field that marketing pages embed. The library
 * keys its singleton loader on these options and logs "Performance warning!
 * LoadScript has been reloaded unintentionally" when two callers disagree, so
 * `LIBRARIES` has to be one module-level array rather than a fresh literal per
 * file: a new array every render is a new identity, and four copies of the same
 * literal are four identities.
 *
 * The key is inlined into the bundle at build time like every REACT_APP_ value,
 * so it is readable by anyone who loads any page. Restricting it by HTTP
 * referrer is what keeps it from being usable elsewhere — see .env.example.
 */
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const GOOGLE_MAPS_LIBRARIES = ["visualization", "places", "geometry"];

/** Spread into `useLoadScript` so every caller shares one loader. */
export const GOOGLE_MAPS_LOADER = {
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
};
